import { render, staticRenderFns } from "./FoodDiary.vue?vue&type=template&id=1a0dd6be"
import script from "./FoodDiary.vue?vue&type=script&lang=js"
export * from "./FoodDiary.vue?vue&type=script&lang=js"
import style0 from "./FoodDiary.vue?vue&type=style&index=0&id=1a0dd6be&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports